import { IExtremeSetData, IExtremeSetNames } from '../models';

const mapSetToGroups: Record<IExtremeSetNames, number> = {
	[IExtremeSetNames.firstSliderName]: 0,
	[IExtremeSetNames.firstMinExtreme]: 0,
	[IExtremeSetNames.firstMaxExtreme]: 0,
	[IExtremeSetNames.secondMinExtreme]: 1,
	[IExtremeSetNames.secondMaxExtreme]: 1,
	[IExtremeSetNames.secondSliderName]: 1,
	[IExtremeSetNames.thirdMinExtreme]: 2,
	[IExtremeSetNames.thirdMaxExtreme]: 2,
	[IExtremeSetNames.thirdSliderName]: 2,
};

export function parseSetListToGroups(setList: IExtremeSetData[]) {
	return setList.map((set) => {
		return Object.keys(set).reduce(
			(
				res: {
					list: Array<Record<string, { text: string; error?: string }>>;
					id?: number;
				},
				key,
			) => {
				if (key === 'id') {
					return {
						...res,
						id: set.id,
					};
				}
				const setGroupIdx = mapSetToGroups[key as IExtremeSetNames];
				const extreme = { [key]: set[key as IExtremeSetNames] };
				let group = res.list[setGroupIdx];

				if (group) {
					group = {
						...group,
						...extreme,
					};
				} else {
					group = extreme;
				}

				res.list[setGroupIdx] = group;
				return res;
			},
			{ list: [] },
		);
	});
}
